import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import PropTypes from 'prop-types';
import md5 from "md5";

import './Login.css'

import {fetchLogin} from '../api/api';

// fetch login/password
const loginUser = async (credentials) => {
  return await fetchLogin(credentials);
}

// md5 hash password
function hash(rawPassword) {
  let hashed = md5(rawPassword);
  return `${hashed}`;
}

export default function Login({setUserToken, setUser, setWelcome}) {
  const [error, setError] = useState({username: null, password: null, connection: null, complete: null, message: null});
  const [input, setInput] = useState({username: null, password: null})

  const navigate = useNavigate()

  useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      const foundUser = JSON.parse(loggedInUser);
      setUserToken(foundUser.token);
      setUser(foundUser.username);
      setWelcome(foundUser.qualitaetsbeauftragter)
    }
  }, [setUserToken, setUser, setWelcome]);

  const handleChange = (event) => {
    let fromInput = input;
    fromInput[event.target.name] = event.target.value;
    setInput(fromInput);
    if (!input.username || !input.password) {
      setError({});
    }
  }

  const handleSubmit = async e => {
    e.preventDefault();
    validateForm();

    if (validateForm()) {
      const userData = await loginUser({
        username: Number(input.username), // Einrichtung-ID is Number
        password: hash(input.password)
      });
      if (userData === 404) {
        setError({username: true, message: "Fehler bei der Anmeldung. ID nicht gefunden"});
      }
      if (userData === 403) {
        setError({password: true, message: "Fehler bei der Anmeldung. PIN ist fehlerhaft"});
      }
      if (userData === 'connection_failed') {
        setError({
          connection: true, message: `Einloggen fehlgeschlagen.
        Bitte versuchen Sie es nochmals oder melden Sie sich bei der Landesärztekammer`
        });
      }
      if (userData === 'survey_completed') {
        setError({
          complete: true, message: `Für die Einrichtung mit der ID ${input.username} wurde für das laufende
        Berichtsjahr schon ein Qualitätsbericht Hämotherapie an die Landesärztekammer übermittelt.`
        });
      } else {
        setUserToken(userData.token);
        setUser(userData.username);
        setWelcome(userData.qualitaetsbeauftragter)
        localStorage.setItem('user', JSON.stringify(userData));
        navigate("/haemotherapieNeu/wilkommen");
      }
    }
  }

  const validateForm = () => {
    let isValid = true;
    let errors = {};

    if (!input["username"]) {
      isValid = false;
      errors["username"] = true;
      errors["message"] = "Bitte füllen Sie die Felder korrekt aus";
    }
    if (!input["password"]) {
      isValid = false;
      errors["password"] = true;
      errors["message"] = "Bitte füllen Sie die Felder korrekt aus";
    }
    setError(errors);

    return isValid;
  }

  return (
    <div className="login-wrapper">
      <h2 className="login_title">Qualitätsbericht Hämotherapie</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <p>Einrichtung-ID</p>
          <input type="text" onChange={handleChange} className={error.username ? "login_error" : "login_input"}
                 autoFocus spellCheck={false} name="username"
          />
        </label>
        <label>
          <p>PIN</p>
          <input type="password" onChange={handleChange} className={error.password ? "login_error" : "login_input"}
                 spellCheck={false} name="password"/>
        </label>
        <div>
          <button type="submit" className="login_btn">Anmelden</button>
        </div>
      </form>
      {(error.username || error.password || error.connection || error.complete) && (
        <div className="error">{error.message}</div>
      )}
    </div>
  )
}

Login.propTypes = {
  setUserToken: PropTypes.func.isRequired,
}
